import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  Box,
  Typography,
  Chip,
  ListItemIcon,
  ListItemText,
  Divider
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import { useGroupContext } from './useGroupContext';

const ContextToggle = () => {
  const {
    currentContext,
    currentGroupName,
    userGroups,
    hasGroups,
    isPersonalMode,
    isGroupMode,
    switchToPersonal,
    switchToGroup,
    loading
  } = useGroupContext();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePersonalSelect = () => {
    switchToPersonal();
    handleClose();
  };

  const handleGroupSelect = (group) => {
    switchToGroup(group.id, group.name);
    handleClose();
  };

  if (loading) {
    return null;
  }

  if (!hasGroups) {
    return (
      <Chip
        icon={<PersonIcon />}
        label="Personal"
        variant="outlined"
        size="small"
        sx={{ color: 'white', borderColor: 'white' }}
      />
    );
  }

  return (
    <Box>
      <Button
        onClick={handleClick}
        endIcon={<ExpandMoreIcon />}
        sx={{
          color: 'white',
          textTransform: 'none',
          minWidth: 'auto',
          px: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {isPersonalMode ? (
            <>
              <PersonIcon sx={{ fontSize: 18 }} />
              <Typography variant="body2">Personal</Typography>
            </>
          ) : (
            <>
              <GroupIcon sx={{ fontSize: 18 }} />
              <Typography variant="body2" sx={{ maxWidth: 120 }} noWrap>
                {currentGroupName}
              </Typography>
            </>
          )}
        </Box>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: { minWidth: 200 }
        }}
      >
        <MenuItem onClick={handlePersonalSelect}>
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography>Personal</Typography>
              {isPersonalMode && <CheckIcon fontSize="small" color="primary" />}
            </Box>
          </ListItemText>
        </MenuItem>

        <Divider />

        {userGroups.map((group) => (
          <MenuItem key={group.id} onClick={() => handleGroupSelect(group)}>
            <ListItemIcon>
              <GroupIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                  <Typography>{group.name}</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {group.role} • {group.member_count} members
                  </Typography>
                </Box>
                {isGroupMode && currentGroupName === group.name && (
                  <CheckIcon fontSize="small" color="primary" />
                )}
              </Box>
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default ContextToggle;